import React from 'react';
import { FiSettings, FiLogOut, FiAward, FiTool, FiActivity } from 'react-icons/fi';
import { useAppContext } from '../context/AppContext';

export const Profile = () => {
  const { user } = useAppContext();

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      {/* Profile Header */}
      <div className="glass-panel rounded-2xl p-6 md:p-8 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-r from-blue-600 to-cyan-600 opacity-20"></div>
        
        <div className="relative z-10 flex flex-col md:flex-row items-center md:items-start gap-6">
          <img src={user.avatar} alt={user.name} className="w-24 h-24 rounded-full border-4 border-slate-800 shadow-xl object-cover" />
          
          <div className="text-center md:text-left flex-1">
            <h1 className="text-2xl font-bold text-white">{user.name}</h1>
            <p className="text-blue-400 font-medium">{user.role}</p>
            <p className="text-sm text-slate-400 mt-1">{user.company}</p>
            
            <div className="flex flex-wrap justify-center md:justify-start gap-3 mt-4">
              <span className="px-3 py-1 bg-slate-800 border border-slate-700 rounded-full text-xs font-medium text-slate-300 flex items-center gap-1">
                Level {user.level} Tech
              </span>
              <span className="px-3 py-1 bg-amber-500/10 border border-amber-500/20 rounded-full text-xs font-medium text-amber-400 flex items-center gap-1">
                {user.streak} Day Streak 
              </span>
            </div>
          </div>
          
          <button className="p-2 text-slate-400 hover:text-white bg-slate-800 rounded-lg absolute top-4 right-4 md:static">
            <FiSettings className="text-xl" />
          </button>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="glass-panel p-4 rounded-xl text-center">
          <FiActivity className="text-blue-400 text-2xl mx-auto mb-2" />
          <div className="text-2xl font-bold text-white">{user.xp}</div>
          <div className="text-xs text-slate-400">Total XP</div>
        </div>
        <div className="glass-panel p-4 rounded-xl text-center">
          <FiTool className="text-emerald-400 text-2xl mx-auto mb-2" />
          <div className="text-2xl font-bold text-white">{user.casesSolved}</div>
          <div className="text-xs text-slate-400">Cases Solved</div>
        </div>
        <div className="glass-panel p-4 rounded-xl text-center">
          <FiAward className="text-amber-400 text-2xl mx-auto mb-2" />
          <div className="text-2xl font-bold text-white">4</div>
          <div className="text-xs text-slate-400">Badges Earned</div>
        </div>
        <div className="glass-panel p-4 rounded-xl text-center">
          <FiActivity className="text-purple-400 text-2xl mx-auto mb-2" />
          <div className="text-2xl font-bold text-white">98%</div>
          <div className="text-xs text-slate-400">Accuracy Rate</div>
        </div>
      </div>

      {/* Settings/Actions */}
      <div className="glass-panel rounded-2xl overflow-hidden">
        <div className="p-4 border-b border-slate-700/50 hover:bg-slate-800/50 cursor-pointer flex justify-between items-center">
          <span className="text-slate-200 font-medium">Account Settings</span>
          <span className="text-slate-500">&rarr;</span>
        </div>
        <div className="p-4 border-b border-slate-700/50 hover:bg-slate-800/50 cursor-pointer flex justify-between items-center">
          <span className="text-slate-200 font-medium">Notification Preferences</span>
          <span className="text-slate-500">&rarr;</span>
        </div>
        <div className="p-4 border-b border-slate-700/50 hover:bg-slate-800/50 cursor-pointer flex justify-between items-center">
          <span className="text-slate-200 font-medium">Offline Mode Settings</span>
          <span className="text-slate-500">&rarr;</span>
        </div>
        <div className="p-4 hover:bg-rose-500/10 cursor-pointer flex items-center gap-2 text-rose-400 font-medium">
          <FiLogOut /> Sign Out
        </div>
      </div>
    </div>
  );
};